import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import AcademyConfigProp from '../propTypes/academyConfig';
import translate from '../../../commonComponents/translate';
import Testimonial from './Testimonial';
import TestimonialSelector from './TestimonialSelector';

function Testimonials({ t, academyConfig }) {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [intervalReset, setIntervalReset] = useState(false);
  const { share = {} } = academyConfig || {};
  const { url = '' } = share;

  const setTestimonial = index => {
    setSelectedIndex(index);
    setIntervalReset(prev => !prev);
  };

  const testimonials = academyConfig?.testimonials || [];

  useEffect(
    () => {
      const tick = () =>
        setSelectedIndex(
          prev => (prev + 2 < testimonials.length ? prev + 2 : 0),
        );
      const id = setInterval(tick, 20000);
      return () => clearInterval(id);
    },
    [intervalReset],
  );

  return testimonials.length > 0 ? (
    <div
      className="landing-testimonial-container"
      itemScope
      itemType="http://schema.org/Review"
    >
      <div className="testimonial-header">
        <h2 className="testimonial-title">{t('landing_testimonials')}</h2>
      </div>
      <hr className="divider-black" />
      <div className="landing-testimonial-overall">
        <Testimonial url={url} testimonial={testimonials[selectedIndex]} />
        {testimonials[selectedIndex + 1] && (
          <Testimonial
            url={url}
            testimonial={testimonials[selectedIndex + 1]}
          />
        )}
      </div>
      {testimonials.length > 2 && (
        <TestimonialSelector
          testimonials={testimonials}
          selectedIndex={selectedIndex}
          onSelection={setTestimonial}
        />
      )}
    </div>
  ) : null;
}

Testimonials.propTypes = {
  t: PropTypes.func.isRequired,
  academyConfig: PropTypes.shape(AcademyConfigProp.propType).isRequired,
};

export default translate(Testimonials);
